export const SORT_DATA = [
  { id: '1', text: '추천순', url: 'rec' },
  { id: '2', text: '최신순', url: 'new' },
  { id: '3', text: '낮은 가격순', url: 'pHigh' },
  { id: '4', text: '높은 가격순', url: 'pLow' },
];
